// @flow
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './LoadingContentFigures.scss';
import icons from '../../assets/styles/icons.scss';

type Props = {
  colorClassName?: string;
  customClass?: string;
  width?: number;
  margin?: string;
};

export const LoadingContentStripe = (props: Props) => (
  <section className={classNames(style.loadingContentStripe, props.colorClassName, props.customClass)}
           style={{ width: !!props.width ? props.width : 'auto', margin: !!props.margin ? props.margin : 0 }}/>
);

export const LoadingContentAvatar = (props: Props) => (
  <section className={classNames(style.loadingContentAvatar, props.colorClassName, props.customClass)}
           style={{ width: !!props.width ? props.width : 'auto', margin: !!props.margin ? props.margin : 0 }}/>
);

export const LoadingContentLabel = (props: Props) => (
  <section className={classNames(style.loadingContentLabel, props.colorClassName, props.customClass)}
           style={{ width: !!props.width ? props.width : 'auto', margin: !!props.margin ? props.margin : 0 }}/>
);

export const LoadingContentInput = () => (
  <section className={style.loadingContentInput}/>
);

export const LoadingContentInputControl = (props: Props) => (
  <section className={style.loadingContentInputControl}>
    <LoadingContentLabel colorClassName={props.colorClassName}/>
    <LoadingContentInput/>
  </section>
);

export const LoadingContentSelect = () => (
  <section className={classNames(style.loadingContentSelect)}>
    <i className={icons.iconChevronDownMedium}/>
  </section>
);

export const LoadingContentSelectControl = (props: Props) => (
  <section className={style.loadingContentSelectControl}>
    <LoadingContentLabel colorClassName={props.colorClassName}/>
    <LoadingContentSelect/>
  </section>
);

export const LoadingContentImage = (props: Props) => (
  <section className={classNames(style.loadingContentImage, props.colorClassName)}>
    <i className={icons.symbolImage}/>
  </section>
);

export const LoadingContentButton = (props: Props) => (
  <section className={classNames(style.loadingContentButton, props.colorClassName)}/>
);


LoadingContentStripe.propTypes = LoadingContentAvatar.propTypes = LoadingContentLabel.propTypes =
  LoadingContentInput.propTypes = LoadingContentInputControl.propTypes = {
    colorClassName: PropTypes.string,
    customClass: PropTypes.string,
    width: PropTypes.number,
    margin: PropTypes.string,
  };



// WEBPACK FOOTER //
// ./src/elements/LoadingContentFigures/LoadingContentFigures.jsx